import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix

/**
 * Class representing a filter view for profile options.
 * @extends JetView
 */
export default class FilterPerfilOpcionesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const screen = this.app.config.size; // Getting the screen size configuration

        // Left section of the layout
        const left = {
            margin: 5,
            rows: [],
        };

        // Center left section of the layout
        const center_left = {
            margin: 5,
            rows: [],
        };

        // Center right section of the layout
        const center_right = {
            margin: 5,
            rows: [],
        };

        // Right section of the layout
        const right = {
            margin: 5,
            rows: [],
        };

        // Upper section combining all layout parts
        const upper_section = {
            cols: [
                left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_left,
                { gravity: 0, minWidth: 10 }, // Spacer
                center_right,
                { gravity: 0, minWidth: 10 }, // Spacer
                right,
            ],
        };

        // Button section with actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Button label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form values
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Gets form values
                        this.app.callEvent('premiosPendientesPagar:filter', [
                            filterdata, // Triggers filter event with form data
                        ]);
                    },
                },
            ],
        };

        // Returns the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons], // Combines upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for fname field
            },
        };
    }
}

// FILE DOCUMENTED
